import axios from 'axios'
import constants from '@/js/constants'

axios.defaults.baseURL = constants.application.defaultURL
axios.defaults.headers.common['Content-Type'] = 'application/json'

export function setAuthToken(token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      window.dispatchEvent(new CustomEvent('auth:unauthorized'))
    }
    return Promise.reject(error)
  }
)

export default axios
